import React from 'react';
import WebpackerReact from 'webpacker-react';
import ClientsDashboard from '../components/admin/Clients/ClientsDashboard';

const ClientsV2Dashboard = (props) => <ClientsDashboard {...props} />;

export default ClientsV2Dashboard;
WebpackerReact.setup({ ClientsV2Dashboard });
